export default __webpack_public_path__ + "static/media/folder.60fa6c1c.png";